/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable  dot-notation */
import React from 'react';
import {
    object, bool, func,
} from 'prop-types';
import { withRouter } from 'react-router';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CloseIcon from '@material-ui/icons/Close';
import withStyles from '@material-ui/core/styles/withStyles';

import customBreakpoints from '../../../../helpers/customBreakpoints';

const styles = (theme) => ({
    cancelButton: {
        width: '100%',
        fontWeight: 'bold',
        fontSize: '15px',
        border: `1px solid ${theme.palette.common?.black}`,
        textTransform: 'none',
        padding: '6px 20px',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttonItem: {
        margin: '0 20px',
    },
    emptyButton: {
        width: '100%',
        fontWeight: 'bold',
        fontSize: '15px',
        color: theme.palette.common?.white,
        backgroundColor: theme.palette.secondary?.main,
        textTransform: 'none',
        padding: '6px 20px',
        '&:hover': {
            backgroundColor: theme.palette.secondary?.main,
        },
    },
    modalPaper: {
        padding: '12px 12px 25px 12px',
        position: 'absolute',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            margin: 0,
            left: 'auto',
            maxWidth: '320px',
        },
    },
    outerDialog: {},
    infoText: {
        fontSize: '22px',
        lineHeight: '24px',
        fontWeight: 600,
        textAlign: 'center',
        margin: 0,
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            fontSize: '16px',
        },
    },
    optionText: {
        color: theme.palette.common.darkGray,
        fontSize: '15px',
        textAlign: 'center',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            fontSize: '14px',
        },
    },
    textContainer: {
        padding: '10px 30px',
    },
    closeButton: {
        textAlign: 'right',
        cursor: 'pointer',
    },
    errorIcon: {
        color: theme.palette.colorPrimary,
        textAlign: 'center',
        '& svg': {
            fontSize: '40px',
        },
    },
});

const CountryRestrictionModal = ({
    classes,
    isOpen,
    onClose,
    emptyCart,
    dataDictionary,
}) => (
    <Dialog
        open={isOpen}
        onClose={onClose}
        className={classes.outerDialog}
        classes={{
            paper: classes.modalPaper,
        }}
        data-testid="country-restriction-modal"
    >
        <Grid item className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
        </Grid>
        <Grid item className={classes.errorIcon}>
            <ErrorOutlineIcon />
        </Grid>
        <Grid item>
            <div className={classes.textContainer}>
                <p className={classes.infoText}>{dataDictionary?.['Your cart contains products from another country and we only allow one country per order'] || 'Your cart contains products from another country and we only allow one country per order'}.</p>
                <p className={classes.infoText}>{dataDictionary?.['Empty your cart to continue with this product'] || 'Empty your cart to continue with this product'}.</p>
                <p className={classes.optionText}>{dataDictionary?.['Please select how you would like to proceed'] || 'Please select how you would like to proceed'}:</p>
            </div>
        </Grid>
        <Grid
            container
            direction="row"
            justify="center"
        >
            <Grid item className={classes.buttonItem}>
                <Button className={classes.cancelButton} onClick={onClose}>
                    {dataDictionary?.['Cancel'] || 'Cancel'}
                </Button>
            </Grid>
            <Grid item className={classes.buttonItem}>
                <Button className={classes.emptyButton} onClick={emptyCart}>
                    {dataDictionary?.['Empty Cart'] || 'Empty Cart'}
                </Button>
            </Grid>
        </Grid>

    </Dialog>
);

CountryRestrictionModal.propTypes = {
    isOpen: bool.isRequired,
    onClose: func.isRequired,
    classes: object.isRequired,
    emptyCart: func.isRequired,
    dataDictionary: object,
};

CountryRestrictionModal.defaultProps = {
    dataDictionary: {},
};

export default withRouter(
    (withStyles(styles)(CountryRestrictionModal)),
);
